$(window).on("load", function () {
	const $fr = $("#Float_right");
	if (!$fr.length) return;

	// ===== milestone: auto active dots theo data-progress (%) =====
	// % của center mỗi dot trên thanh bar 372px (dot tại left: 23/104/185/266/347, +16 center, -1 bar offset)
	const DOT_PERCENTS = [10.2, 31.7, 53.5, 75.3, 97];
	$fr.find(".milestone[data-progress]").each(function () {
		const pct = Math.max(0, Math.min(100, parseFloat($(this).data("progress")) || 0));
		$(this).find(".bar-active").css("width", pct + "%");
		$(this).find(".dot").each(function (i) {
			$(this).toggleClass("dot-active", pct >= DOT_PERCENTS[i]);
		});
	});

	// Anchor: bài viết thứ 5 (.post-card:eq(4)) — trigger compact khi scroll qua bài này.
	// Fallback: nếu chưa đủ 5 post (production load async), dùng post cuối cùng có sẵn.
	// Fallback cuối: 800px cố định nếu không có post nào.
	function getAnchor() {
		const $posts = $("#nth-ld-frame2 .post-card");
		if ($posts.length >= 5) return $posts.eq(4);
		if ($posts.length > 0) return $posts.last();
		return null;
	}

	const FULL_H = 2337;
	const COMPACT_H = 773;
	const ANIM_MS = 350;
	const BUFFER = 60; // hysteresis px

	function measureTrigger() {
		const $a = getAnchor();
		return $a && $a.length ? $a.offset().top : 800;
	}

	let triggerY = measureTrigger();
	let elHeight = FULL_H;
	let lastScrollY = 0;
	let ticking = false;
	let animating = false;
	let rafId = null;

	// MutationObserver: khi .posts thêm post mới (async load), re-measure trigger.
	// Production load post động → .post-card:eq(4) có thể chưa tồn tại lúc window.load.
	const postsContainer = document.querySelector("#nth-ld-frame2 .posts");
	if (postsContainer) {
		new MutationObserver(function () {
			triggerY = measureTrigger();
		}).observe(postsContainer, { childList: true });
	}

	function getOffset(h) {
		const vh = $(window).height();
		const max = Math.max(0, 107 + h - vh);
		return -Math.min(lastScrollY, max);
	}

	function animateHeight(toH) {
		if (rafId) cancelAnimationFrame(rafId);
		const fromH = elHeight;
		animating = true;
		const start = performance.now();

		function step(now) {
			const t = Math.min(1, (now - start) / ANIM_MS);
			const ease = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
			elHeight = fromH + (toH - fromH) * ease;
			$fr.css("transform", "translate3d(0, " + getOffset(elHeight) + "px, 0)");
			if (t < 1) {
				rafId = requestAnimationFrame(step);
			} else {
				elHeight = toH;
				animating = false;
				rafId = null;
			}
		}
		rafId = requestAnimationFrame(step);
	}

	function apply() {
		ticking = false;
		if (animating) return;

		const isCompact = $fr.hasClass("is-compact");
		// hysteresis: vào compact khi scrollY > triggerY, ra compact khi scroll lên dưới triggerY - BUFFER
		const shouldCompact = isCompact
			? lastScrollY > triggerY - BUFFER
			: lastScrollY > triggerY;

		if (shouldCompact !== isCompact) {
			$fr.toggleClass("is-compact", shouldCompact);
			animateHeight(shouldCompact ? COMPACT_H : FULL_H);
			return;
		}

		$fr.css("transform", "translate3d(0, " + getOffset(elHeight) + "px, 0)");
	}

	function onScroll() {
		lastScrollY = $(window).scrollTop();
		if (!ticking && !animating) {
			window.requestAnimationFrame(apply);
			ticking = true;
		}
	}

	lastScrollY = $(window).scrollTop();
	apply();

	$(window).on("scroll", onScroll);
	$(window).on("resize", function () {
		if (rafId) cancelAnimationFrame(rafId);
		animating = false;
		rafId = null;
		// Re-measure trigger sau resize (MS__wrapper scale có thể đổi, layout shift)
		triggerY = measureTrigger();
		elHeight = $fr.hasClass("is-compact") ? COMPACT_H : FULL_H;
		onScroll();
	});
});
